export const LOGIN: string = 'src/pages/login/LOGIN';
export const LOGIN_SUCCESS: string = 'src/pages/login/LOGIN_SUCCESS';
export const LOGIN_FAILED: string = 'src/pages/login/LOGIN_FAILED';


export const GENERATE_OPT: string = 'src/pages/login/GENERATE_OPT';
export const GENERATE_OPT_SUCCESS: string = 'src/pages/login/GENERATE_OPT_SUCCESS';
export const GENERATE_OPT_FAILED: string = 'src/pages/login/GENERATE_OPT_FAILED';

export const VERIFY_OPT: string = 'src/pages/login/VERIFY_OPT';
export const VERIFY_OPT_SUCCESS: string = 'src/pages/login/VERIFY_OPT_SUCCESS';
export const VERIFY_OPT_FAILED: string = 'src/pages/login/VERIFY_OPT_FAILED';
